import { OperationModels } from '../../../kernel/base-entities'
import { JobState } from './job'
import { StepState, StepTypeNames, TaskNames, TaskState } from './task'
import FleetCapability = TaskNames

export enum CurrencyCode {
  USD = 'USD',
  CAD = 'CAD',
  EUR = 'EUR',
  BTC = 'BTC',
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ARS = 'ARS',
  AUD = 'AUD',
  AZN = 'AZN',
  BAM = 'BAM',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BWP = 'BWP',
  BYR = 'BYR',
  BZD = 'BZD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GNF = 'GNF',
  GTQ = 'GTQ',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KHR = 'KHR',
  KMF = 'KMF',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MOP = 'MOP',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SOS = 'SOS',
  SVC = 'SVC',
  SYP = 'SYP',
  THB = 'THB',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  XAF = 'XAF',
  XOF = 'XOF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMK = 'ZMK'
}

export enum PackageState {
  NOT_USING = 'NOT_USING',
  USING = 'USING',
  RESCHEDULED = 'RESCHEDULED',
  DELIVERED = 'DELIVERED'
}

enum PaymentType {
  BASE = 'BASE',
  ON_TIME = 'ON_TIME',
  ORDER_COMPLETED = 'ORDER_COMPLETED'
}

enum FleetType {
  OWN = 'OWN',
  THREE_PL = '3PL',
  CROWD_SOURCE = 'CROWD_SOURCE'
}

export enum DeliveryOptionKeys {
  DELIVERY_CODE = 'DELIVERY_CODE',
  CONTACT_LESS = 'CONTACT_LESS',
  ROUND_TRIP = 'ROUND_TRIP',
  CURBSIDE = 'CURBSIDE'
}

enum PricesType {
  ORDER_VALUE = 'order_value',
  SHIPPING_FEE = 'shipping_fee',
  TAXES = 'taxes',
  DISCOUNTS = 'discounts',
  SUBTOTAL = 'subtotal'
}

enum PaymentMethod {
  CASH = 'CASH',
  PREPAID = 'PREPAID',
  PAYMENT_TERMINAL = 'PAYMENT_TERMINAL',
  LOYALTY_CARD = 'LOYALTY_CARD',
  PAYMENT_LINK = 'PAYMENT_LINK',
  TRANSFER = 'TRANSFER'
}

enum PaymentStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
  CHANGED = 'CHANGED',
  IN_PROGRESS = 'IN_PROGRESS',
  REVERTED = 'REVERTED'
}

enum BlockingPolicy {
  CHECKOUT = 'CHECKOUT',
  EXIT_STORE = 'EXIT_STORE',
  UNBLOCKED = 'UNBLOCKED',
  ASSIGNATION = 'ASSIGNATION',
  PICKING_VERIFICATION = 'PICKING_VERIFICATION'
}

export enum ItemState {
  PENDING = 'PENDING',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
  CANCELLED = 'CANCELLED',
  REJECTED_BY_PICKER = 'REJECTED_BY_PICKER',
  REJECTED_BY_DRIVER = 'REJECTED_BY_DRIVER',
  REJECTED_BY_USER = 'REJECTED_BY_USER',
  REJECTED = 'REJECTED'
}

enum ClaimAction {
  REFUND = 'REFUND',
  SUBSTITUTE = 'SUBSTITUTE',
  COLLECT_AND_REFUND = 'COLLECT_AND_REFUND',
  COLLECT_AND_SUBSTITUTE = 'COLLECT_AND_SUBSTITUTE',
  REJECT = 'REJECT',
  REJECTION_NOT_ALLOWED = 'REJECTION_NOT_ALLOWED'
}

enum ClaimState {
  IN_PROGRESS = 'IN_PROGRESS',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED'
}

export enum PackageTransferState {
  PENDING = 'PENDING',
  SCANNED = 'SCANNED'
}

export interface LocationResponse {
  name: string
  address: string
  address_two: string
  country: string
  state: string
  city: string
  zip_code: string
  description: string
  coordinates: {
    lat: number
    lng: number
  }
}

// ITEM

type ItemAttributesType = string | number

interface ItemAttributes {
  [attribute: string]: ItemAttributesType
}

interface PickingInfo {
  was_multi_order: boolean
  mode: string
  scanned_barcode: string | null
  scanned_barcodes?: string[]
  lot: string | null
  lots?: string[]
}

interface ClaimInformation {
  max_claim_date: string
  available_claim_actions: ClaimAction[]
}

interface RejectionInformation {
  rejection_reason: string | null
  claim_action: ClaimAction | null
  claim_state: ClaimState | null
  evidence: string[] | null
  comment: string | null
  resolution_reason?: string | null
}

interface RejectedQuantity {
  rejected_by_picker: number
  rejected_by_driver: number
  rejected_by_user: number
}

interface FormatPresentation {
  quantity: number
  format: string
  equivalence: number
}

interface ItemPresentationV2Response {
  unit: string
  sub_unit: string
  quantity: number
  sub_quantity: number
  price: number
  weight: number
  volume: number
  formats: FormatPresentation | null
}

interface ItemQuantityFoundLimits {
  min: number | null
  max: number | null
}

export interface Item {
  id: string
  state: ItemState
  name: string
  package_id: string | null
  quantity: number
  found_quantity: number
  photo_url: string
  presentation: {
    quantity: number
    unit: string
    sub_unit: string
    sub_quantity: number
    name: string
    price: {
      amount: number
      currency_code: string
    }
    weight: number | null
    volume: number | null
    dimensions: number[]
  }
  attributes: ItemAttributes
  origin: string
  comment: string
  is_substitute: boolean
  replaced_by: string | null
  reference: string
  picking_info: PickingInfo | null
  claim_information: ClaimInformation | null
  rejection_information: RejectionInformation | null
  rejected_quantity: RejectedQuantity
  barcodes: string[] | null
  package_reference: string | null
  presentation_v2: ItemPresentationV2Response
  picking_task_id: string
  quantity_found_limits: ItemQuantityFoundLimits | null
}
// ITEM

export type PaymentDetails = {
  [paymentType in PaymentType]?: number
}

interface PaymentSummary {
  currencyCode: CurrencyCode
  total: number
  details: PaymentDetails
}

export interface Step {
  id: string
  type: StepTypeNames
  state: StepState
  active: boolean
  optimal_start_time: string | null
  optimal_end_time: string | null
  actual_start_time: string | null
  actual_end_time: string | null
  ordering: number
}

interface FleetAssignationAlgorithms {
  bipartite: boolean
  routing: boolean
  batching?: boolean
}

type PaymentRatePerCapability = {
  [fleetCapability in FleetCapability]?: PaymentDetails
}

interface PaymentRate {
  currencyCode: CurrencyCode
  paymentRatePerCapability: PaymentRatePerCapability
}

interface FleetResponse {
  id: string
  name: string
  type: FleetType
  capabilities: FleetCapability[]
  client_id: string
  client_reference: string
  saturation: number
  fleet_assignation_algorithms: FleetAssignationAlgorithms
  departments: string[]
  payment_rate: PaymentRate | null
}

interface RouteInTaskResponse {
  id: string
  route_number: string
  ordering: number
}

export interface ResourceInformation {
  id: string
  first_name: string
  last_name: string
  photo_url: string
  phone_number: string
}

export interface Task {
  id: string
  type: TaskNames
  state: TaskState
  optimal_start_time: string | null
  optimal_end_time: string | null
  resource: string | null
  resource_information: ResourceInformation | null
  payment: PaymentSummary | null
  steps: Step[]
  fleet: FleetResponse | null
  route: RouteInTaskResponse | null
  departments: string[]
  store_id: string | null
  stop_metadata: StopMetadataResponse | null
  last_assigned_resource_information: ResourceInformation | null
}

interface StopMetadataResponse {
  order: number
  store_name: string
}

export interface DeliveryOptions {
  method: DeliveryOptionKeys
  [key: string]: string | number | null
}

interface ExternalData {
  backoffice: Data | null
  shopperApp: Data | null
  webhook: Data | null
}

interface Data {
  [data: string]: string
}

interface Invoice {
  reference: string
  attachments: string[]
  metadata: any | null
}

interface PricesAttributes {
  type: PricesType
  name: string
  value: number
}

interface AdditionalInfoPrices {
  name: string
  value: string
  type: string
}

interface PricesResponse {
  order_value: number
  shipping_fee: number | null
  taxes: number
  discounts: number
  subtotal: number
  attributes: PricesAttributes[]
  additional_info: AdditionalInfoPrices[]
}

interface PaymentResponse {
  id: string | null
  method: PaymentMethod
  method_details: string | null
  reference: string | null
  payment_status: PaymentStatus | null
  payment_status_details: string | null
  value: number
  blocking_policy: BlockingPolicy | null
  metadata: {} | null
  qr_string: string | null
}

interface PaymentInfoResponse {
  currency_code: CurrencyCode
  prices: PricesResponse
  payment: PaymentResponse
  invoice: Invoice | null
}

interface Dimensions {
  x: number
  y: number
  z: number
}

export interface CartonizationPackageConstraints {
  id: string
  clientId: string
  storeId: string
  minimumUtilizationPercentage: number
  name: string
  maximumQuantity: number
  maximumVolume: number
  maximumWeight: number
  dimensions: Dimensions | null
  allowedDepartments: string[] | null
  allowBigItems: boolean
  shortName: string
}

interface PackageResponse {
  id: string
  job_id: string
  store_id: string
  reference: string | null
  zone: string | null
  state: PackageState
  transfer_state: PackageTransferState
  was_updated: boolean
  name: string | null
  department: string | null
  cartonization_constraints: CartonizationPackageConstraints | null
}

interface DeliveryValidationsResponse {
  type: string
  photo_url: string | null
  checked_at: string
}

interface SlotResponseModel {
  id: string
  from: string
  to: string
  operational_model: OperationModels
}

export interface NebulaJob {
  id: string
  job_number: string
  client_id: string
  start_time: string
  end_time: string
  created_at: string
  state: JobState
  operational_model: OperationModels
  origin: LocationResponse
  destination: LocationResponse
  total_items: number
  items_replaced: number
  products_cost: {
    amount: number
    currency: string
  }
  items: Item[]
  collect_with: {
    method: string
    payment: {
      amount: number
      currency: string
    }
  }
  recipient: {
    name: string
    email: string
    phone_number: string
  }
  can_process_checkout: boolean
  can_process_exit_store: boolean
  automatic_checkout: boolean
  delivery_options: DeliveryOptions[]
  job_comment: string | null
  tasks: Task[]
  external_data: ExternalData | null
  payment_info: PaymentInfoResponse
  store: {
    id: string
    reference: string
    name: string
    time_zone: string
  }
  is_big_order: boolean
  source: string
  updated_at: string
  issue_of: string | null
  packages: PackageResponse[]
  delivery_validations: DeliveryValidationsResponse[] | null
  pick_up_code: string | null
  slot: SlotResponseModel
}
